<template>
  <bdg-input-template
    class="free-response-multi-select"
    :name="name"
    @focusout="onFocusout"
    :invalid="isInvalid"
    :loading="loading"
    :required="required"
  >
    <multi-select
      :class="{ invalid: isInvalid }"
      :empty-state-message="emptyStateMessage"
      :begin-typing-message="beginTypingMessage"
      :search-function="searchFunction"
      @add-new="$emit('add-new', $event)"
      v-model="computedValue"
      :can-add="canAdd"
      :is-qty="isQty"
    />
  </bdg-input-template>
</template>

<script>
import BdgInputTemplate from "./BdgInputTemplate";
import MultiSelect from "./MultiSelect";

export default {
  name: "BdgMultiSelect",
  extends: BdgInputTemplate,
  components: { MultiSelect, BdgInputTemplate },
  props: {
    emptyStateMessage: String,
    beginTypingMessage: String,
    searchFunction: Function,
    value: Array,
    canAdd: Boolean,
    isQty: Boolean
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    isValid() {
      return !!this.computedValue && this.computedValue.length;
    }
  },
  methods: {
    onFocusout() {
      this.isInvalid = this.required && !this.isValid;
    }
  }
};
</script>
